import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section id="bonuses" className="defer-paint w-full scroll-mt-6 bg-ivory py-10 sm:py-12" aria-labelledby="bonuses-heading" data-id="element-15" data-mp="gx6o4606sc9x">
      <div className="mx-auto max-w-5xl px-6" data-id="element-16" data-mp="vqjmpbguhmu7">
        <SectionHeading eyebrow="The 7-piece teacher toolkit" eyebrowTone="gold" title={<span id="bonuses-heading" data-id="element-18" data-mp="14t2khh5rx99l">7 practical teacher bonuses</span>} lead="120 classes solve what to teach. These seven bonuses cover when to use each class, how to cue it, how to modify it — and what to do when you have no time." data-id="element-17" data-mp="qsrsgasq9omu" />

        <ul className="mt-8 grid gap-4 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4" data-id="element-19" data-mp="1eiuiymgzumjc">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col overflow-hidden rounded-2xl border border-line bg-shell shadow-soft" data-id="element-20" data-mp="19ksxxw00cd58">
              {/* The cover art runs edge to edge — no padding, no letterboxing. */}
              <img src={bonus.image} alt={bonus.alt} className="aspect-[3/4] w-full object-cover" width={960} height={1280} sizes="(max-width: 640px) 45vw, (max-width: 1024px) 30vw, 220px" loading="lazy" decoding="async" data-id="element-21" data-mp="1jgnn79yql6gz" />

              <div className="flex flex-1 flex-col p-3.5" data-id="element-22" data-mp="2lvu6m99mdom">
                <p className="font-sans text-[9px] font-semibold uppercase tracking-[0.18em] text-gold-ink" data-id="element-23" data-mp="2kb3j7q2new1">
                  Bonus {bonus.number}
                </p>
                <h3 className="mt-1.5 font-display text-[0.95rem] leading-snug text-ink" data-id="element-24" data-mp="ciqvfcwxas6l">
                  {bonus.title}
                </h3>
                <p className="mt-auto pt-2 font-sans text-[0.75rem] leading-relaxed text-stone" data-id="element-25" data-mp="gj0xwflib0gp">
                  {bonus.tagline}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}